var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoofSlate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.125 0.9375H10.6875V8.0625H19.125V0.9375ZM19.4062 8.625H19.125H15.75V14.625H20.25H20.8125H24.75V8.625H19.6875H19.4062ZM15.1875 8.625H10.6875H10.125H6V14.625H10.125H10.6875H15.1875V8.625ZM10.125 8.0625V0.9375H0.9375V8.0625H10.125ZM25.3125 8.625V14.625H29.0625V8.625H25.3125ZM5.4375 14.625L5.4375 8.625H0.9375V14.625H5.4375ZM10.6875 15.1875H20.25V22.6875H10.6875V15.1875ZM15.75 23.25H20.25H20.8125H24.75V29.0625H15.75V23.25ZM25.3125 29.0625V23.25H29.0625V29.0625H25.3125ZM15.1875 23.25H10.6875H10.125H6V29.0625H15.1875V23.25ZM5.4375 23.25L5.4375 29.0625H0.9375V23.25H5.4375ZM29.0625 22.6875H20.8125V15.1875H29.0625V22.6875ZM30 29.0625V23.25V22.6875V15.1875V14.625V0.9375V0H29.8125H29.25H29.0625H19.6875H19.125H10.6875H10.125H0.9375H0.5625H0V0.5625V0.9375V8.0625V8.625V14.625V15.1875V22.6875V23.25V29.0625V30H0.9375H29.0625H30V29.0625ZM10.125 15.1875H0.9375V22.6875H10.125V15.1875ZM19.6875 0.9375V8.0625H29.0625V0.9375H19.6875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofSlate);
export default __webpack_public_path__ + "static/media/roof-slate.c40a2c89a666eaf366917ca49543a3cb.svg";
export { ForwardRef as ReactComponent };